import React, { useContext, useState, useEffect, useRef } from 'react';
import gsap from 'gsap';

import { UIContext } from 'context/ui';

import Arrow from 'assets/svg/small-arrow.svg';

import s from './PageNav.scss';
import { useIntl } from 'react-intl';


interface IProps {
  children?: React.ReactNode;
  heading: string;
  parentHeading?: string;
}

export const PageNav = ({ heading, parentHeading, children }: IProps) => {
  if (!children && !heading) {
    return null;
  }

  const { isDesktop } = useContext<any>(UIContext);
  const [open, toggle] = useState(false);
  const listRef = useRef<HTMLUListElement>(null);
  const t = gsap.timeline();
  const intl = useIntl();

  useEffect(() => {
    if (!listRef.current) {
      return;
    }

    if (isDesktop) {
      gsap.set(listRef.current, { height: 'auto'});
    } else {
      

      if (open) {
        t.to(listRef.current, { height: 'auto', duration: 0.4 });
      } 
      else {
        t.to(listRef.current, { height: 0, duration: 0.2 });
      }
    }

  }, [isDesktop, open]);

  return (
    <div className={s.pageNav}>
      <div className={s.pageNav__inner}>
        <div className={s.pageNav__hgroup}>
          {parentHeading && (<div className={s.pageNav__parentHeading}>{parentHeading}</div>)}
          <h1 className={s.pageNav__heading}>{heading}</h1>
        </div>
        <div className={s.pageNav__listWrap}>
          {!isDesktop && (
            <button className={s.pageNav__button} onClick={() => toggle(!open)}>
              {intl.formatMessage({ id: 'menu', defaultMessage: 'Valmynd' })}
              <Arrow className={s.pageNav__buttonArrow} />
            </button>
          )}
          <ul className={s('pageNav__list', { open })} ref={listRef}>
            {children}
          </ul>
        </div>
      </div>
    </div>
  );
};

interface IItemProps {
  children: React.ReactNode;
  active?: boolean;
}

export const Item = ({ children, active }: IItemProps) => {
  return <li className={s('pageNav__item', { active })}>{children}</li>;
};
